"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var query_1 = require("./query");
var reconnecting_eventsource_1 = require("./reconnecting-eventsource");
var sbtech_general_api_client_1 = require("sbtech-general-api-client");
exports.sbtFetch = sbtech_general_api_client_1.sbtFetch;
exports.tokenService = sbtech_general_api_client_1.tokenService;
var SportsDataApiClient = /** @class */ (function () {
    function SportsDataApiClient(config) {
        this.config = config;
        this.events = new EntityEndpoint("Events", config.sportsApiUrl);
        this.markets = new EntityEndpoint("Markets", config.sportsApiUrl);
        this.leagues = new EntityEndpoint("Leagues", config.sportsApiUrl);
        this.regions = new EntityEndpoint("Regions", config.sportsApiUrl);
        this.sports = new EntityEndpoint("Sports", config.sportsApiUrl);
    }
    return SportsDataApiClient;
}());
exports.SportsDataApiClient = SportsDataApiClient;
var EntityEndpoint = /** @class */ (function () {
    function EntityEndpoint(entityType, apiUrl) {
        this.entityType = entityType;
        this.apiUrl = apiUrl;
    }
    EntityEndpoint.prototype.pull = function (query) {
        var queryString = query_1.Query.composeQueryString(query);
        var queryUrl = this.apiUrl + "/" + this.entityType + queryString;
        return sbtech_general_api_client_1.sbtFetch(queryUrl).get();
    };
    EntityEndpoint.prototype.subscribe = function (query, onNext, onError) {
        var getToken = function () { return sbtech_general_api_client_1.tokenService.apiAccessToken; };
        var queryString = query_1.Query.composeQueryString(query);
        var queryUrl = this.apiUrl + "/stream/" + this.entityType + queryString + "&jwt=" + JWT_PLACEHOLDER;
        var subscription = new SseSubscription(queryUrl, query, getToken, onNext, onError);
        subscription.run();
        return subscription;
    };
    return EntityEndpoint;
}());
exports.EntityEndpoint = EntityEndpoint;
var SseSubscription = /** @class */ (function () {
    function SseSubscription(url, query, getToken, onNext, onError) {
        this.url = url;
        this.query = query;
        this.getToken = getToken;
        this.onNext = onNext;
        this.onError = onError;
    }
    SseSubscription.prototype.run = function () {
        var _this = this;
        if (!this.onNext) {
            throw Error("onNext can't be nullable.");
        }
        this.eventSource = new reconnecting_eventsource_1.ReconnectingEventSource(this.getUrl());
        this.eventSource.addEventListener("push", function (e) {
            _this.onNext(JSON.parse(e.data));
        }, false);
        this.eventSource.addEventListener("update", function (e) {
            _this.onNext(JSON.parse(e.data));
        }, false);
        this.eventSource.addEventListener("snapshot", function (e) {
            _this.onNext(JSON.parse(e.data));
        }, false);
        this.eventSource.onerror = function (e) {
            if (_this.onError) {
                _this.onError(Error("EventSource failed."));
            }
        };
        this.eventSource.onreconnect = function () {
            _this.eventSource.url = _this.getUrl();
        };
    };
    SseSubscription.prototype.unsubscribe = function () {
        this.eventSource && this.eventSource.close();
    };
    SseSubscription.prototype.getUrl = function () {
        return this.url.replace(JWT_PLACEHOLDER, this.getToken());
    };
    return SseSubscription;
}());
var JWT_PLACEHOLDER = "JWT_PLACEHOLDER";
//# sourceMappingURL=api.js.map